import {
  CONFIRM_AUTHENTALINK_REQUEST,
  CONFIRM_AUTHENTALINK_SUCCESS,
  CONFIRM_AUTHENTALINK_FAILURE,
  CONFIRM_AUTHENTALINK_PIN_FAILURE,
  CLEAR_AUTHENTALINK_FAILURE,
  VERIFY_PIN_SUCCESS,
  VERIFY_PIN_REQUEST,
  VERIFY_PIN_ERROR,
  SHOW_PIN_VERIFICATION,
  HIDE_PIN_VERIFICATION,
  REQUEST_PIN,
  REQUEST_PIN_ERROR,
  REQUEST_PIN_SUCCESS,
  REQUEST_PIN_CONFIRMATION,
  REQUEST_PIN_CONFIRMATION_SUCCESS,
  REQUEST_PIN_CONFIRMATION_ERROR,
  REQUEST_PIN_CONFIRMATION_CLEAR
} from 'actions';

// eslint-disable-next-line default-param-last
function authentaLink(state = {
  authenticationPinVerified: false,
  authenticatingVerificationPin: false,
  pinVerificationMessages: null,
  showPinVerification: false,
  requestingVerificationPin: false,
  pinRequestStatus: false,
  items: []
}, action) {
  switch (action.type) {
    case CONFIRM_AUTHENTALINK_REQUEST:
      return {
        ...state,
        isAuthenticating: true,
        isFailed: false,
        errorCode: null,
        errorMessage: null
      };
    case CONFIRM_AUTHENTALINK_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
        isFailed: false,
        resendReference: action.resendReference
      };
    case CONFIRM_AUTHENTALINK_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        isFailed: true,
        errorCode: action.code,
        errorMessage: action.message
      };
    case CLEAR_AUTHENTALINK_FAILURE:
      return {
        ...state,
        isFailed: false,
        errorCode: null,
        errorMessage: null
      };
    case CONFIRM_AUTHENTALINK_PIN_FAILURE:
      return {
        ...state,
        authenticatingVerificationPin: false,
        pinVerificationMessages: action.message,
        pinRequestStatus: false
      };
    case REQUEST_PIN_CONFIRMATION:
      return {
        ...state,
        sendingConfirmation: true,
        confirmationMessage: null
      };
    case REQUEST_PIN_CONFIRMATION_SUCCESS:
      return {
        ...state,
        sendingConfirmation: false,
        confirmationStatus: true,
        confirmationMessage: action.message
      };
    case REQUEST_PIN_CONFIRMATION_ERROR:
      return {
        ...state,
        sendingConfirmation: false,
        confirmationStatus: false,
        confirmationMessage: action.message
      };
    case REQUEST_PIN_CONFIRMATION_CLEAR:
      return {
        ...state,
        sendingConfirmation: false,
        confirmationStatus: true,
        confirmationMessage: null
      };
    case VERIFY_PIN_SUCCESS:
      return {
        ...state,
        authenticationPinVerified: true,
        authenticatingVerificationPin: false,
        pinVerificationMessages: null,
        pinRequestStatus: true
      };
    case VERIFY_PIN_REQUEST:
      return {
        ...state,
        authenticatingVerificationPin: true,
        pinVerificationMessages: null,
        pinRequestStatus: false
      };
    case VERIFY_PIN_ERROR:
      return {
        ...state,
        authenticatingVerificationPin: false,
        pinVerificationMessages: action.message,
        pinRequestStatus: false
      };
    case SHOW_PIN_VERIFICATION:
      return {
        ...state,
        showPinVerification: true
      };
    case HIDE_PIN_VERIFICATION:
      return {
        ...state,
        showPinVerification: false,
        authenticatingVerificationPin: false,
        pinVerificationMessages: null
      };
    case REQUEST_PIN:
      return {
        ...state,
        requestingVerificationPin: true,
        pinVerificationMessages: null,
        pinRequestStatus: false
      };
    case REQUEST_PIN_ERROR:
      return {
        ...state,
        requestingVerificationPin: false,
        pinRequestStatus: false,
        pinVerificationMessages: action.message
      };
    case REQUEST_PIN_SUCCESS:
      return {
        ...state,
        requestingVerificationPin: false,
        pinRequestStatus: true,
        pinVerificationMessages: action.message
      };
    default:
      return state;
  }
}

export default authentaLink;
